/**
 * Quién hizo un cambio, legible (issue #111).
 *
 * Hasta el 2026-11-03 las cuatro bitácoras —gastos, ingresos, novedades y
 * viajes— pintaban `usuario 1684dfee`: el `actor` es el `app_user.id` y el
 * frontend no tenía forma de traducirlo, porque `GET /users` responde 403 al
 * Operador y al Ejecutivo y `GET /users/{id}` no está implementado. Ahora el
 * core manda el nombre resuelto en `actorName`.
 *
 * El respaldo se queda **a propósito**: una respuesta de antes del arreglo, o
 * un usuario borrado, no deben dejar la celda vacía.
 */
export function nombreDeActor(actor: string, actorName?: string): string {
  if (actor === 'system') return 'automático';
  // El core degrada al propio id cuando no puede resolver el nombre; en ese
  // caso vale más el id recortado que repetirlo entero.
  if (actorName && actorName !== actor) return actorName;
  return `usuario ${actor.slice(0, 8)}`;
}
